module.exports = __webpack_public_path__ + "static/media/rm_06-16.866f7af0.png";